import type { Doc } from "building-types/doc";
import type { OptionTemplateHandle } from "building-types/handles/docEntityHandleTypes";
import type {
  DocOptionSetOverrides,
  DocOptionTemplate,
  OptionSetOverrides,
} from "building-types/options/optionTemplateTypes";
import type { Table, RWTable } from "common/data/table";
import { docEntityGetSortedChildrenFromTable } from "./entity/docEntityGetChildrenFromTable";
import { docOptionSetOverridesNormalize } from "./options/docOptionSetOverrides";

export function docGetActiveOptionTemplate(doc?: Pick<Doc, "optionTemplates">): DocOptionTemplate | null {
  if (doc?.optionTemplates) {
    for (const template of Object.values(doc.optionTemplates)) {
      if (!template.disabled) {
        return template;
      }
    }
  }
  return null;
}

export function docGetOptionTemplateOverridesByOptionSetId(
  doc: Doc,
  { id: optionTemplateId }: OptionTemplateHandle,
): Table<DocOptionSetOverrides> {
  const output: RWTable<DocOptionSetOverrides> = {};
  if (doc) {
    docEntityGetSortedChildrenFromTable(doc.optionSetOverrides, optionTemplateId).forEach(
      (x) => (output[x.optionSetId] = x),
    );
  }
  return output;
}

export function docGetActiveOptionTemplateOverrides(
  doc?: Pick<Doc, "optionTemplates" | "optionSetOverrides"> | null,
): OptionSetOverrides | null {
  if (doc) {
    const template = docGetActiveOptionTemplate(doc);
    if (template) {
      return docOptionSetOverridesNormalize(doc.optionSetOverrides, template.id);
    }
  }
  return null;
}
